<button *ngIf="!hasEditors && !inCompletionState() && !isLoading" color="primary" mat-raised-button
	(click)="chooseToEditNode();">
	<span *ngIf="denied || !hasNodeCreatorPermission()"><i class="fa fa-ban fa-fw"></i>&nbsp; Not Authorized</span>
	<span *ngIf="!denied && hasNodeCreatorPermission()">Edit this Item</span>
</button>

<button *ngIf="isEditor && !inCompletionState() && !isLoading" color="primary" mat-raised-button
	(click)="chooseToNotEditNode();">
	<span *ngIf="denied || !hasNodeCreatorPermission()"><i class="fa fa-ban fa-fw"></i>&nbsp; Not Authorized</span>
	<span *ngIf="!denied">Release this item</span>
</button>